import Parser from '@core/components/contentparser/Parser';

const Contents = ({ data }) => {
	return <Parser data={data} origin="my-uni" />;
};

export default Contents;
